import { ApiEndPoint } from './apiEndPoint'

export const getCalendarEvents = new ApiEndPoint('calendar/{start}/{end}')

export const getAppointmentById = new ApiEndPoint('calendar/appointment/{appointmentId}')
export const getLabels = new ApiEndPoint('calendar/labels')
